// src/layout/DashboardLayout.jsx
import { Layout } from "antd";
import { useState, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { logoutSuccess } from "../store/slices/authSlice";
import { resetAll as resetFile } from "../store/slices/fileSlice";
import { persistor } from "../store";
import Sidebar from "./Sidebar";
import { resetPerformanceSummaryCache } from "../hooks/usePerformanceSummary";

const { Content } = Layout;

const DashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const user = useSelector((state) => state.auth.user);
  const subscription = useSelector((state) => state.auth.subscription);


  // Format user info for profile section
  const userInfo = useMemo(() => {
    if (!user) return null;
    
    const getInitials = (name) => {
      if (!name) return "U";
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    };

    return {
      name: user  || "User",
      initials: getInitials(user  || "User"),
      subscription: subscription || "Free",
    };
  }, [user, subscription]);

  const handleLogout = async () => {
    try {
      try { await persistor.purge(); } catch (e) {}
      try { localStorage.clear(); } catch (e) {}
      try { sessionStorage.clear(); } catch (e) {}
      try { sessionStorage.removeItem("analyticsConfig"); } catch (e) {}

      dispatch(resetFile());
      dispatch(logoutSuccess());
      resetPerformanceSummaryCache();

      toast.success("Successfully logged out!",{theme: "colored"});
    } finally {
      navigate("/", { replace: true });
    }
  };

  return (
    <Layout className="w-full h-[100dvh] bg-gray-900 overflow-hidden">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        navigate={navigate}
        handleLogout={handleLogout}
        userInfo={userInfo}
      />

      <Layout className="bg-[#1C1C1E] min-h-0 overflow-hidden">
        <Content className="h-full overflow-hidden">
          <div className="h-full w-full overflow-y-auto flex justify-center">
            <div className="w-full max-w-[1400px]">
              <Outlet />
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;